export const ANIMATE_TYPES = {
    GROW: 'grow',
    ZOOM: 'zoom',
    FADE: 'fade',
    SLIDE: 'slide',
    COLLAPSE: 'collapse'
};
